import { WorkspaceSettingsItem } from '@modules/workspaceSettings/components/WorkspaceSettingsItem';
import { ApprovedDomainsInfoTooltip } from '@modules/workspaceSettings/components/ApprovedDomains/ApprovedDomainsInfoTooltip';
import { DomainUsersTable } from '@modules/users/components/DomainUsersTable';
import { MarkEmailReadRounded } from '@mui/icons-material';

export const ApprovedDomains = () => {
  return (
    <WorkspaceSettingsItem
      icon={<MarkEmailReadRounded sx={{ color: 'text.secondary' }} />}
      title="Approved Domains"
      titleAction={<ApprovedDomainsInfoTooltip />}
      paperProps={{
        sx: {
          py: 2,
        },
      }}
    >
      <DomainUsersTable />
    </WorkspaceSettingsItem>
  );
};
